import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AccountsContextService } from '../../accounts/account-context.service';
import { FundsSummaryData } from './payments.types';


@Injectable({
  providedIn: 'root',
})
export class AdvertiserPaymentsService {

  public totalFunds$: BehaviorSubject<number|null> = new BehaviorSubject<number|null>(null);
  private _fundsSummary$: BehaviorSubject<FundsSummaryData|null> = new BehaviorSubject<FundsSummaryData|null>(null);

  constructor (
    private accountContextService: AccountsContextService,
    private http: HttpClient,
  ) {}

  public get fundsSummary$(): Observable<FundsSummaryData|null> {
    return this._fundsSummary$.asObservable();
  }

  public fetchFundsSummary(advertiserId?: string): void {
    const accountId = this.accountContextService.accountId;
    this.http
      .get(`${environment.billingBaseUrl}/funds/summary`, {
        params: {
          advertiserId: accountId ?? advertiserId
        }
      })
      .pipe(
        map((response: any) => response.data),
        map((response: FundsSummaryData) => {
          return {
            ...response,
            totalFundsAvailable: response.bonus + response.prepaid + response.creditLineAvailable
          }})
      )
      .subscribe(
        (summary: FundsSummaryData) => {
          this.totalFunds$.next(summary.totalFundsAvailable);
          return this._fundsSummary$.next(summary);
        },
      );
  }
}
